import { Scene } from "three";

export default class DtScene extends Scene {
    constructor() {
        super();
    }
}